import React, { forwardRef, useRef } from 'react'
import { Controller } from 'react-hook-form'
import { Button, Modal, Input, FormItem } from '@ow/comps'
import useForm from './hooks/use-edit-pwd'

const PWD_REG =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,16}$/
const UpdatePwdModal = function ({ user = {}, closeModal, updatePwd }, ref) {
  const formRef = useRef(null)
  const { control, setError, errors } = useForm(formRef)

  const onSubmit = () => {
    const data = formRef.current.getValues()
    const { password, password_confirm } = data
    if (password_confirm !== password) {
      setError('password_confirm', {
        type: 'manual',
        message: '两次密码输入不一致～ 请重新输入',
      })
    } else {
      formRef.current.trigger().then((tr) => {
        if (tr) {
          updatePwd(user.id, password, () => {
            if (closeModal) {
              closeModal()
            }
          })
        }
      })
    }
  }

  return (
    <Modal
      ref={ref}
      title="修改密码"
      size="md"
      showCloseButton
      closeOnDocumentClick={false}
      onClose={closeModal}
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={() => {
        return (
          <div className="w-full flex flex-row justify-end">
            <Button stroke onClick={closeModal} className="mr-2">
              取消
            </Button>
            <Button type="primary" onClick={onSubmit}>
              确定
            </Button>
          </div>
        )
      }}
    >
      <div className="flex flex-col -mt-2 mb-20 h-52">
        <div className="flex flex-col">
          <FormItem
            required
            label="新密码"
            error={
              errors.password &&
              errors.password.type === 'pattern' && (
                <p className="text-red-500 text-sm">
                  用户密码至少8个字符，不超过16个字符，必须包含符号、数字和大小写字母组合
                </p>
              )
            }
            className="w-full mt-2"
          >
            <Controller
              render={({ field }) => {
                return (
                  <Input
                    {...field}
                    placeholder="请输入"
                    className="w-full mt-2"
                    type="password"
                    onChange={(e) => {
                      field.onChange(e)
                    }}
                  />
                )
              }}
              name="password"
              rules={{ required: true, pattern: PWD_REG }}
              control={control}
              defaultValue=""
            />
          </FormItem>
        </div>

        <div className="flex flex-col">
          <FormItem
            required
            label="重复密码"
            error={
              errors.password_confirm &&
              errors.password_confirm.message && (
                <p className="text-red-500 text-sm">
                  {errors.password_confirm.message}
                </p>
              )
            }
            className="w-full mt-2"
          >
            <Controller
              render={({ field }) => {
                return (
                  <Input
                    {...field}
                    placeholder="请输入"
                    className="w-full mt-2"
                    onChange={(e) => {
                      field.onChange(e)
                    }}
                    type="password"
                  />
                )
              }}
              name="password_confirm"
              rules={{ required: true }}
              control={control}
              defaultValue=""
            />
          </FormItem>
        </div>
      </div>
    </Modal>
  )
}

export default forwardRef(UpdatePwdModal)
